import loadable from 'utils/loadable';
import React from "react";

export default loadable(() => import('./DestinationSearch'), {fallback: (
        <>
            <p className="tw-mt-1 tw-text-white tw-uppercase font-sp">
                Where are you going?<br/>
            </p>
            <p className="tw-text-white tw-mt-1 tw-pl-1">
                Select...
            </p>
        </>
    )});
